<template>
  <b-sidebar
    id="add-new-sidebar"
    :visible="isAddNewSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    width="50%"
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">
          Make new Mail Notification
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <!-- Skill Name -->
          <validation-provider
            #default="validationContext"
            name="title"
            rules="required"
          >
            <b-form-group
              label="Title"
              label-for="title"
            >
              <b-form-input
                id="name"
                v-model="catData.title"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Skill Slug -->
          <validation-provider
            #default="validationContext"
            name="link"
            rules=""
          >
            <b-form-group
              label="Link"
              label-for="link"
            >
              <b-form-input
                id="link"
                v-model="catData.link"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Skill Slug -->
          <validation-provider
            #default="validationContext"
            name="body"
            rules="required"
          >
            <b-form-group
              label="Body"
              label-for="body"
              :state="getValidationState(validationContext)"
            >
              <quill-editor
                v-model="catData.body"
                required
              />

              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="image"
            rules=""
          >
            <b-form-group
              label="Image"
              label-for="image"
              :state="getValidationState(validationContext)"
            >
              <b-form-file
                v-model="catData.image"
                accept="image/jpeg, image/png, image/gif"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                :multiple="false"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="userType"
            rules="required"
          >
            <b-form-group
              label="User Type"
              label-for="userType"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="catData.userType"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="userTypeOptions"
                :reduce="(val) => val.value"
                :clearable="false"
                input-id="userType"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <!-- Form Actions -->
          <validation-provider
            #default="validationContext"
            name="isActive"
            rules=""
          >
            <b-form-group
              label=""
              label-for="isActive"
            >
              <b-form-checkbox
                v-model="catData.isActive"
              >
                Is Active
              </b-form-checkbox>

              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
              </div></b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="isVerified"
            rules=""
          >
            <b-form-group
              label=""
              label-for="isVerified"
            >
              <b-form-checkbox
                v-model="catData.isVerified"
              >
                Is Verified
              </b-form-checkbox>

              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
              </div></b-form-group>
          </validation-provider>
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              Add
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormFile,
  BFormGroup,
  BFormCheckbox,
  BFormInput,
  BFormDatepicker,
  BFormInvalidFeedback,
  BButton,
} from 'bootstrap-vue'
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";

import { quillEditor } from 'vue-quill-editor'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

import useSkillsList from './useMailNotificationsList'

export default {
  components: {
    quillEditor,
    BSidebar,
    BFormCheckbox,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormFile,

    vSelect,
    BFormDatepicker,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewSidebarActive',
    event: 'update:is-add-new-sidebar-active',
  },
  props: {
    isAddNewSidebarActive: {
      type: Boolean,
      required: true,
    },

    skillStatuses: {
      type: Array,
      required: true,
    },
  },
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    // 15th two months prior
    const minDate = new Date(today)
    minDate.setMonth(minDate.getMonth() - 2)
    minDate.setDate(15)
    // 15th in two months
    const maxDate = new Date(today)
    maxDate.setMonth(maxDate.getMonth() + 2)
    maxDate.setDate(15)
    return {
      min: minDate,
      max: maxDate,
      userTypeOptions: [{ label: 'Company', value: 'company' },
        { label: 'Investor', value: 'investor' }, { label: 'Freelancer', value: 'freelancer' }, { label: 'Broker', value: 'broker' },
        { label: 'Advisor', value: 'advisor' }, { label: 'Partner', value: 'partner' },
        { label: 'All Users', value: 'all' }],
      required,
      alphaNum,
      email,
    }
  },
  setup(props, { emit }) {
    const { addSkill } = useSkillsList()

    const blankSkillData = {
      title: null,
      body: null,
      link: null,
      isVerified: false,
      isActive: false,
      image: null,
    }
    const catData = ref(JSON.parse(JSON.stringify(blankSkillData)))
    const resetCatData = () => {
      catData.value = JSON.parse(JSON.stringify(blankSkillData))
    }

    const onSubmit = async () => {
      const response = await addSkill(catData.value)
      if (typeof response !== 'undefined') {
        emit('refetch-data')
        emit('update:is-add-new-sidebar-active', false)
      }
    }

    const { refFormObserver, getValidationState, resetForm } = formValidation(resetCatData)

    return {
      catData,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.ql-container {
  min-height: 15rem;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.ql-editor {
  height: 100%;
  flex: 1;
  overflow-y: auto;
  width: 100%;
}
#add-new-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
